const state = {
  uniqueSearch: true, // to track unique search in ratio to one page view
  uniqueClickOut: true,
  behaviourFunnel: [],
  firstInteraction: true,
  inAppBrowser: false,
  uniqueId: '',
  trackingIsAllowed: true,
  trackHostNames: [
    'www.urlaubspiraten.de', // Germany
    'www.urlaubspiraten.at', // Austria
    'www.travlepirates.com', // USA
    'www.holidaypirates.com', // United Kingdom
    'www.piratinviaggio.it', // Italy
    'www.vakantiepiraten.nl', // Netherland
    'www.wakacyjnipiraci.pl', // Poland
    'www.voyagespirates.fr', // France
    'www.viajerospiratas.es', // Spain
    'www.ferienpiraten.ch', // Switzerland
    'localhost' // for development
  ]
}

const getters = {
  getUniqueSearch: state => {
    return state.uniqueSearch
  },
  getUniqueClickOut: state => {
    return state.uniqueClickOut
  },
  getFirstInteraction: state => {
    return state.firstInteraction
  },
  getInAppBrowser: state => {
    return state.inAppBrowser
  },
  getUniqueId: state => {
    return state.uniqueId
  },
  getTrackingIsAllowed: state => {
    return state.trackingIsAllowed
  },
  getTrackingHostNames: state => {
    return state.trackHostNames
  }
}

const mutations = {
  updateUniqueSearch: state => {
    state.uniqueSearch = false
  },
  updateUniqueClickOut: state => {
    state.uniqueClickOut = false
  },
  updateFirstInteraction: state => {
    state.firstInteraction = false
  },
  updateInAppBrowser: (state, inappbrowser) => {
    state.inAppBrowser = inappbrowser
  },
  updateUniqueId: (state, uniqueId) => {
    state.uniqueId = uniqueId
  },
  updateTrackingIsAllowed: state => {
    state.trackingIsAllowed = false
  }
}

const actions = {
  updateUniqueSearch: ({ commit }) => {
    commit('updateUniqueSearch')
  },
  updateUniqueClickOut: ({ commit }) => {
    commit('updateUniqueClickOut')
  },
  updateFirstInteraction: ({ commit }) => {
    commit('updateFirstInteraction')
  },
  updateInAppBrowser: ({ commit }, inappbrowser) => {
    commit('updateInAppBrowser', inappbrowser)
  },
  updateUniqueId: ({ commit }, uniqueId) => {
    commit('updateUniqueId', uniqueId)
  },
  updateTrackingIsAllowed: ({ commit }) => {
    commit('updateTrackingIsAllowed')
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
